module.exports = __webpack_public_path__ + "static/media/glotio_logo_purple.3cdf647e.svg";